import { AccessLevel, getLevelName } from "./access-level.enum";
import { PaymentProvider } from "./payment-provider.enum";

export class UserModel {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  accessLevel: AccessLevel;
  username: string;
  isActive: boolean;
  customerId: number;
  hasPaymentProfile: boolean;
  notificationOptOut: boolean;
  paymentProfileAccountId: string;
  paymentProfileId: string;
  allowAutomaticPayments: boolean;
  automaticChargeLimit: number;
  autoChargeDisabled: boolean; // true if any user in account has it activated
  inviteAccepted: boolean;
  paymentProvider: PaymentProvider;
  clientId: number;
  leadId: number;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get accessLevelName(): string {
    return getLevelName(this.accessLevel);
  }

  constructor(model?: Partial<UserModel>) {
    Object.assign(this, model);
  }
}
